import { Container, Grid } from '@mui/material';
import { ToolbarSimulations } from '@sections/simulations/toolbar-simulations';
import { useSimulationsPage } from './use-simulations-page';
import { AgaveDataGrid, AgavePagination } from '@components/agave-data-grid';
import columns from '@sections/simulations/columns.tsx';
import useServerPagination from '@hooks/use-server-pagination.ts';
import { GridRowParams } from '@mui/x-data-grid';
import { InductionArea } from '@components/induction-area/induction-area.tsx';
import Breadcrumb from '@/components/breadcrumb';

export const SimulationsPage = () => {
  const { filters } = useServerPagination();
  const hooks = useSimulationsPage(filters);

  return (
    <>
      <Breadcrumb
        sections={[{ label: 'Simulaciones' }]}
        description="Lista de simulaciones"
        actions={
          <ToolbarSimulations
            date={hooks.date}
            rows={hooks.rows}
            onDownload={hooks.onDownload}
            onChangeDate={hooks.onChangeDate}
            loadingDownload={hooks.loadingDownload}
            loadingInduction={hooks.loadingInduction}
            inductSelection={hooks.inductSelection}
            startInduction={hooks.startInduction}
          />
        }
      />
      <Container sx={{ padding: 2 }}>
        <Grid container spacing={1}>
          <Grid component="div" size={{ xs: 12 }}>
            <AgaveDataGrid
              className="px-4"
              autoHeight
              rows={hooks.rows}
              rowCount={hooks.total}
              loading={hooks.loading}
              disableColumnMenu
              columns={columns}
              paginationMode="server"
              getRowId={(row) => row._id}
              checkboxSelection
              isRowSelectable={(params: GridRowParams) =>
                params?.row?.induct_accept == 'accepted'
              }
              disableRowSelectionOnClick={true}
              onRowSelectionModelChange={hooks.onRowSelectionModelChange}
              getRowHeight={() => 'auto'}
              getRowClassName={() => 'py-2'}
              pageSizeOptions={[10, 25, 50, 100]}
              slots={{
                pagination: AgavePagination,
              }}
            />
          </Grid>
        </Grid>
      </Container>
      {hooks.show_induction && (
        <InductionArea routes={hooks.routes} onClose={hooks.closeInduction} />
      )}
    </>
  );
};
